import { useNavigate } from 'react-router';
import { useRequest } from 'domain/core/hooks/useRequest';
import { ApiMethodsEnum } from 'infrastructure/enums/ApiMethodsEnum';
import { storageService } from 'infrastructure/services/StorageService';
import { showSystemToast } from 'view/components/SystemToast';

export const useUserLogOut = (): any => {
  const navigate = useNavigate();
  const { error, send, status } = useRequest({
    url: '/api/v1/auth/logout',
    method: ApiMethodsEnum.Post,
    sendOnStart: false,
  });

  if (!error && (status === 200 || status === 204)) {
    storageService.removeItem('accessToken').then();
    storageService.removeItem('refreshToken').then();
    navigate('/auth/login', { replace: true });
    showSystemToast('success', 'Success', 'You are successfully Logged Out');
  }

  return { send };
};
